import React, { useState } from 'react';


//CREATE A LOADINGCONTEXT WITH DEFAULT VALUES
export const LoadingContext = React.createContext({
  isLoading: false, //DEFAULT VALUE
  setIsLoading: (isLoading: boolean) => {}, //FUNCTION TO SET THE VALUE
});

export const LoadingProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [isLoading, setIsLoading] = useState(false);
  
    //RETURN THE LOADINGCONTEXT PROVIDER WITH CURRENT STATE AND SETTER
    return (
      <LoadingContext.Provider value={{ isLoading, setIsLoading }}>
        {children}
      </LoadingContext.Provider>
    );
  };